<p class="sp-m-0" [ngClass]="['drawer-paragraph-' + size, 'color-' + contrast, 'weight-' + weight]">{{ text }}</p>
